import { Dialog, Grid } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import { StepConfig } from '../../../../../redux/views/viewsTypes'
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks'
import { DialogHeader } from '../../../../../components/features/Dialog/BasicDialog'
import { ImportSteps } from '../../../../../redux/imports/importsTypes'
import { EnvName } from '../../../../../redux/user/userTypes'
import { FileConfigForm } from '../ImportDialogContent'
import { DataType } from '../Import'
import { fetchCompany } from '../../../../../redux/companies/companiesSlice'

interface OwnProps {
    step: number,
    config: StepConfig,
    filesToImport: string | string[],
    envNames: string[],
    companyName: string,
    dataType: DataType
}

export const FileConfigStep = ({ config, step, filesToImport, envNames, companyName, dataType }: OwnProps) => {
    return (
        <Grid container direction="column" height="100%" justifyContent="space-between" flexWrap="nowrap">
            <DialogHeader
                title="Finalisez l’import de votre fichier"
                setOpen={() => {
                    config.handleReset()
                }}
            />
            <FileConfigForm config={config} step={step} files={filesToImport} envNames={envNames} companyName={companyName} dataType={dataType} />
        </Grid >
    )
}

const stepsSync: Record<
    string,
    (step: number, config: StepConfig, filesToImport: any, envNames: string[], companyName: string, dataType: DataType) => JSX.Element
> = {
    [ImportSteps.Default]: (step: number, config: StepConfig, filesToImport: any, envNames: string[], companyName: string, dataType: DataType) => (
        <FileConfigStep step={step} config={config} filesToImport={filesToImport} envNames={envNames} companyName={companyName} dataType={dataType} />
    )
}

const ImportValidationDialog = ({
    isOpen,
    handleClose,
    handleSend,
    files,
    dataType
}: {
    isOpen?: boolean
    handleClose: () => void
    handleSend: (filename: string) => void
    files: string[] | string,
    dataType: DataType
}) => {
    const { config } = useAppSelector((state) => state.imports)
    const { fileName } = useAppSelector((state) => state.imports.fileData)
    const userEnvs = useAppSelector((state) => state.user.user.env)
    const companyName = useAppSelector((state) => state.companies.company.name)
    const [activeStep, setActiveStep] = useState<number>(0)
    const dispatch = useAppDispatch()
    const userEnvsNames = userEnvs && userEnvs.filter((env) => env.name != EnvName.SETTING).map((el) => el.name)

    const handleReset = () => {
        handleClose()
        setActiveStep(0)
    }

    const handlePrevious = () => {
        setActiveStep(activeStep - 1)
    }

    const handleSubmit = () => {
        handleSend(fileName)
        setActiveStep(0)
    }

    const _fetchCompany = useCallback(
        async () => await dispatch(fetchCompany()),
        [dispatch]
    )

    useEffect(() => {
        _fetchCompany()
    }, [])
    const StepComponent = stepsSync[config.steps[activeStep]]

    return (
        <Dialog
            maxWidth={false}
            onClose={(e: any) => {
                e.stopPropagation()
                handleClose()
            }}
            open={isOpen}
            PaperProps={{
                sx: {
                    borderRadius: '1em',
                    width: '70vw',
                    padding: '1em',
                    height: '70vh',
                },
            }}
        >
            {StepComponent(activeStep, {
                handleClose,
                handlePrevious,
                handleReset,
                handleSubmit,
                stepsNumber: config.steps.length,
            }, files, userEnvsNames, companyName, dataType)}
        </Dialog>
    )
}

export default ImportValidationDialog
